const indexItems = [
  { title: '2026暑期档观影完全指南', desc: '30部精选影片 + 观影顺序推荐', icon: 'ri-sun-line', color: 'accent' },
  { title: '豆瓣9分以上神作合集', desc: '百部口碑炸裂的高分电影一网打尽', icon: 'ri-star-line', color: 'accent' },
  { title: '动作片爱好者必看清单', desc: '肾上腺素飙升的视觉盛宴精选', icon: 'ri-flashlight-line', color: 'primary' },
  { title: '悬疑烧脑电影精选', desc: '看完让人反复回味的反转佳作', icon: 'ri-lightbulb-line', color: 'secondary' },
  { title: '周末轻松喜剧推荐', desc: '治愈系笑片，承包你的快乐周末', icon: 'ri-emotion-laugh-line', color: 'accent' },
  { title: '科幻迷终极片单', desc: '从硬核科幻到太空歌剧的深度指南', icon: 'ri-rocket-line', color: 'primary' },
  { title: '经典港片怀旧专场', desc: '重温黄金年代不可错过的港片经典', icon: 'ri-vidicon-line', color: 'secondary' },
];

export default function Index() {
  const getColorClasses = (color: string) => {
    if (color === 'accent') return 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-white';
    if (color === 'primary') return 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white';
    return 'bg-secondary-100 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-white';
  };

  return (
    <section id="index" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            专题合集
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            精心策划的观影专题，帮你发现更多好电影
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.slice(0, 3).map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group flex items-start gap-3 p-4 md:p-5 rounded-xl bg-background-50 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <div className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg flex-shrink-0 transition-colors ${getColorClasses(item.color)}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
          {indexItems.slice(3).map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group flex items-start gap-3 p-4 md:p-5 rounded-xl bg-background-50 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <div className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg flex-shrink-0 transition-colors ${getColorClasses(item.color)}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}